/**
 * KEEP TAB INSIDE AN OPEN OVERLAY (0.1.507).
 *
 * `aria-modal` hides the page behind a sheet from assistive tech, but it does nothing for the
 * keyboard: a Tab from the last control walked straight out of the panel into the list underneath
 * (the product audit, 10 Sep 2026). The nav sheet has trapped Tab since 0.1.368 with its own
 * button-only walk; this is the third overlay to need one — the shared bottom `Sheet` and the
 * option `picker` — so the walk is hoisted here (the DRY rule's third occurrence).
 *
 * Wire it from the panel's own `onKeyDown`, which means it only sees keys while focus is already
 * inside — the caller focuses the panel (tabIndex -1) on open so the first Tab starts from it.
 * Last → first, shift+first → last; a panel with nothing focusable keeps focus on itself.
 */
const FOCUSABLE =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function trapTab(e: { key: string; shiftKey: boolean; preventDefault: () => void }, panel: HTMLElement | null): void {
  if (e.key !== 'Tab' || panel === null) return;
  const focusable = Array.from(panel.querySelectorAll<HTMLElement>(FOCUSABLE)).filter((el) => el.offsetParent !== null);
  if (focusable.length === 0) {
    e.preventDefault();
    return;
  }
  const first = focusable[0]!;
  const last = focusable[focusable.length - 1]!;
  const active = document.activeElement;
  if (e.shiftKey && (active === first || active === panel)) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && (active === last || active === panel)) {
    e.preventDefault();
    first.focus();
  }
}
